export type JwtPayload = {
  exp?: number;
  [key: string]: unknown;
};

const decodeBase64Url = (input: string): string | null => {
  if (!input) return null;
  const normalized = input.replace(/-/g, "+").replace(/_/g, "/");
  const padding = normalized.length % 4;
  const padded = padding ? normalized + "=".repeat(4 - padding) : normalized;
  try {
    return atob(padded);
  } catch (_err) {
    return null;
  }
};

export const decodeJwtPayload = (token: string): JwtPayload | null => {
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  const payloadSegment = parts[1];
  if (!payloadSegment) return null;
  const decoded = decodeBase64Url(payloadSegment);
  if (!decoded) return null;
  try {
    return JSON.parse(decoded) as JwtPayload;
  } catch (_err) {
    return null;
  }
};

export const getJwtExpiryMs = (token?: string | null): number | null => {
  if (!token) return null;
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") return null;
  return payload.exp * 1000;
};
